import React from 'react';
import { Switch } from '@mui/material';
import ColorPicker from '../../puck/reusable-props/ColorPicker';
import WithAccordion from './CustomAccordion';
import { Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

export interface IBackgroundProps {
  color: string;
  isInherit: boolean;
  hoverColor?: string;
}

interface IProps {
  value: IBackgroundProps;
  onChange: (_value: IBackgroundProps) => void;
  title?: string;
  label?: string;
  isAddHover?: boolean;
}

const BackgroungColorComponent = ({
  value,
  onChange,
  title = 'Background',
  label,
  isAddHover = false,
}: IProps) => {
  return (
    <WithAccordion title={title}>
      <div className="flex justify-between items-center mb-3">
        <p className="text-sm font-semibold">Inherit Parent</p>
        <div className="flex gap-0.5 items-center">
          <Tooltip
            title={
              'If enabled, the background color will be inherited from the parent container.'
            }
            placement="top-start">
            <InfoIcon fontSize="small" className="h-1 w-1" />
          </Tooltip>
          <Switch
            checked={value?.isInherit}
            onChange={e =>
              onChange({
                ...value,
                isInherit: e.target.checked,
              })
            }
          />
        </div>
      </div>
      {!value?.isInherit && (
        <>
          <ColorPicker
            label={label ?? 'Background Color'}
            tooltip="backgroundColor"
            onChange={color =>
              onChange({
                ...value,
                color,
                isInherit: value?.isInherit ?? false,
              })
            }
            value={value?.color}
          />
          {isAddHover && (
            <ColorPicker
              label={'Hover Color'}
              tooltip="hoverColor"
              onChange={color =>
                onChange({
                  ...value,
                  hoverColor: color,
                })
              }
              value={value?.hoverColor}
            />
          )}
        </>
      )}
    </WithAccordion>
  );
};

export default BackgroungColorComponent;
